module.exports = __webpack_public_path__ + "logo2.png?32d8ceae79759527a7654021a3198ffc";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo2.png
// module id = 391
// module chunks = 0